import Chair from './Chair';
// import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class StoolLog extends Chair {
  constructor({ game, location, data }) {
    super({ game, location, data });
  }

  createAsset() {
    this.asset = this.game.make.image(0, 0, this.data.key, 'stool_log');
    this.asset.anchor.set(0.5, 1);

    this.addChild(this.asset);
  }
}
